// slug
// import React from "react";
// import { useProjectMap } from "../../api/main_Map/useProjectMap";
// import { BASE_URL_IMG } from "../../api/apiConfig";

// function Roads({ slug }) {
//   console.log("🚨 Roads component rendered");

// const { projectData, loading } = useProjectMap(slug) || {};

//   if (loading || !projectData?.roads_svg) return null;

//   const roadImage = `${BASE_URL_IMG}/${projectData.roads_svg}`;
// console.log("projectData:", projectData);
// console.log("roads_svg:", projectData?.roads_svg);
// console.log("roadImage:", roadImage);

//   return (
//     <div
//       style={{
//                position: "absolute",
//         width: "100%",
//         height: "100%",
//         left: 0,
//         top: 0,
//       }}
//     >
//       <img
//         src={roadImage}
//         alt="Roads"
//         style={{
//           width: "100%",
//           height: "100%",
//           objectFit: "contain",
//         }}
//       />
//     </div>
//   );
// }

// export default Roads;















import React from "react";
import { useProjectMap } from "../../api/main_Map/useProjectMap";
import { BASE_URL_IMG } from "../../api/apiConfig";

function Roads() {
  const { projectData, loading } = useProjectMap("sadan") || {};
  if (loading || !projectData?.roads_svg) return null;

  const roadImage = `${BASE_URL_IMG}/${projectData.roads_svg}`;


  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
      }}
    >
      <img
        src={roadImage}
        alt="Roads"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  );
}

export default Roads;